import gql from "graphql-tag";
import getPreviousStep from "state/getPreviousStep";

export const gotoPreviousStepMutation = gql`
  mutation gotoPreviousStep {
    gotoPreviousStep @client
  }
`;

const completeStepQuery = gql`
  query CompleteStepQuery {
    wizard @client {
      currentStep
    }
  }
`;

export const gotoPreviousStep = (_, args, { cache }) => {
  const { wizard } = cache.readQuery({ query: completeStepQuery });

  const data = {
    wizard: {
      __typename: "Wizard",
      currentStep: getPreviousStep(wizard.currentStep),
    },
    articleMatchesPage: 1,
  };

  cache.writeData({ data });
  return null;
};



// WEBPACK FOOTER //
// ./src/mutations/gotoPreviousStepMutation.js